import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, ResultListDto, TicketInvoiceApprovalSettingDto, TicketInvoiceDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpTicketInvoiceApprovalPaymentService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/ticket/invoice/approval', authService);
	}

	public getSettings(): Observable<TicketInvoiceApprovalSettingDto[]> {
		return super.doGet(true, `/settings`);
	}
	public modifySettings(payload: TicketInvoiceApprovalSettingDto[]): Observable<TicketInvoiceApprovalSettingDto[]> {
		return super.doPost(true, `/settings`, payload);
	}
	public getSettingAgents(): Observable<AgentDto[]> {
		return super.doGet(true, `/settingAgents`);
	}

	public getPendingInvoices(pageIndex?: number, pageSize?: number): Observable<ResultListDto<TicketInvoiceDto>> {
		return super.doGet(true, `/pending?pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
	}
	public getApprovedInvoices(fromDate: Date, toDate: Date): Observable<TicketInvoiceDto> {
		const sFromDate = this.toApiDate(fromDate);
		const sToDate = this.toApiDate(toDate);

		return super.doGet(true, `/approved?fromDate=${sFromDate}&toDate=${sToDate}`);
	}
	public doApproval(payload: TicketInvoiceDto[], reason: string, pageSize?: number): Observable<ResultListDto<TicketInvoiceDto>> {
		return super.doPost(true, `/submit?pageIndex=0&pageSize=${pageSize ?? 20}&reason=${encodeURI(reason)}`, payload);
	}

}
